import type { EvidenceUploadMode, ModelResults } from 'api';

import { formatBaleReason } from '../formatBaleReason';
import { getAnalysisStatus } from './getAnalysisStatus';

export const getAnalysisStatusAndRejectionReason = (
  mode: EvidenceUploadMode,
  model_results: ModelResults,
  useGradeService = false
) => {
  const imageRejected = model_results.outputs?.[0]?.image_rejected;
  const status = getAnalysisStatus(mode, model_results, useGradeService);

  return {
    analysisStatus: imageRejected ? 'rejected-photo' : status,
    photoRejectedReason: imageRejected
      ? formatBaleReason(model_results.outputs?.[0]?.image_rejection_reasons?.[0])
      : undefined,
  };
};
